import { lightgray, whiteColor } from 'theme/color';

export const statusCard = () => ({
  // height: "187px",
  background: whiteColor,
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  border: '0.5px solid #E4E4E4',
  borderRadius: '5px',

  marginBottom: '20px',
  '.MuiGrid-root': {
    flexGrow: '1',
  },
});

export const moreInfoContainer = {
  marginTop: '10px',
  padding: '8px 14px',
  borderRadius: '8px',
  background: lightgray,
};

export const switchStyle = () => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'white',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    background: 'linear-gradient(162.58deg, #6C2AD2 1.87%, #77CFFE 98.78%)',
  },
});

export const textTransform = () => ({
  fontSize: '14px',
  color: '#666666',
  fontFamily: 'Poppins',
  fontWeight: '400',
  minHeight: '40px',
  padding: '5px !important',
  '& .MuiTouchRipple-root': {
    textTransform: 'none !important',
  },
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6C2AD2',
  },
  '&.Mui-indicator': {
    backgroundColor: '#6C2AD2 !important',
    height: '3px',
  },
});
export const maptextTransform = () => ({
  fontSize: '14px',
  color: '#666666',
  fontFamily: 'Poppins',
  fontWeight: '400',
  minHeight: '40px',
  padding: '10px 10px 10px 10px',
  '& .MuiTouchRipple-root': {
    textTransform: 'none !important',
  },
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6C2AD2',
  },
  '&.Mui-indicator': {
    backgroundColor: '#6C2AD2 !important',
    height: '3px',
  },
});

export const listtextTransform = () => ({
  fontSize: '14px',
  color: '#666666',
  fontFamily: 'Poppins',
  fontWeight: '400',
  minHeight: '40px',
  padding: '10px 10px 10px 10px',
  '& .MuiTouchRipple-root': {
    textTransform: 'none !important',
  },
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6C2AD2',
  },
  '&.Mui-indicator': {
    backgroundColor: '#6C2AD2 !important',
    height: '3px',
  },
});
